<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      :loading="loading"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      :checkbox-config="{
        highlight: true,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-warning">
            <span style="font-size: 14px; color: #606266">
              {{ $l('INDEX.order_inspection_doc_label_title') || '验货文档' }}
            </span>
          </div>
        </slot>
      </template>
      <template v-slot:expandContent="{ row }">
        <BatchTable
          class="m-2"
          :code="row.orderInspectionDocCode"
          :getData="getBatchData"
        />
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_downloada') || '下载'"
          placement="top"
        >
          <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
        </el-tooltip>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import BatchTable from '../batch-table'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { BatchTable },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    downloadFile({ fileCode = '' }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
    async getBatchData(code) {
      if (!code) return []
      const res = await this.$api.pendingOrderInspectionDocBatchListApi({
        orderInspectionDocCode: code,
      })
      return res.body.data || []
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}
</style>
